import type { FestivalConfig } from "./types";

// Official organiser pages checked on 20 September 2026. Coordinates identify
// the festival area for weather, not an entrance or a navigation destination.
// Unverified capacities and future dates are deliberately left unpopulated.
export const FESTIVAL_ADDITIONS: FestivalConfig[] = [
  {
    "slug": "glastonbury",
    "name": "Glastonbury",
    "city": "Worthy Farm, Pilton",
    "country": "UK",
    "lat": 51.15,
    "lng": -2.59,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 23,
      "monthEnd": 6,
      "dayEnd": 27
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "multi-genre",
      "rock",
      "indie"
    ],
    "website": "https://www.glastonburyfestivals.co.uk/info/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.glastonburyfestivals.co.uk/info/"
    },
    "cardOneLiner": "Music, theatre and late-night discoveries across Worthy Farm.",
    "blurb": "Music, theatre and late-night discoveries across Worthy Farm.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-23",
        "end": "2027-06-27",
        "sourceUrl": "https://www.glastonburyfestivals.co.uk/info/",
        "checkedAt": "2026-09-20"
      }
    ],
    "excludedYears": [
      {
        "year": 2026,
        "reason": "Fallow year",
        "sourceUrl": "https://www.glastonburyfestivals.co.uk/info/"
      }
    ],
    "relatedGuideSlug": "glastonbury-jobs",
    "jobsFilter": "season=festival&location=fest-glastonbury"
  },
  {
    "slug": "kendal-calling",
    "name": "Kendal Calling",
    "city": "Lowther Deer Park, Cumbria",
    "country": "UK",
    "lat": 54.6,
    "lng": -2.74,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 29,
      "monthEnd": 8,
      "dayEnd": 1
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "indie",
      "rock",
      "multi-genre"
    ],
    "website": "https://kendalcalling.co.uk/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://kendalcalling.co.uk/"
    },
    "cardOneLiner": "Live bands and woodland discoveries in the Lake District.",
    "blurb": "Live bands and woodland discoveries in the Lake District.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-29",
        "end": "2027-08-01",
        "sourceUrl": "https://kendalcalling.co.uk/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-kendal-calling"
  },
  {
    "slug": "victorious",
    "name": "Victorious",
    "city": "Southsea, Portsmouth",
    "country": "UK",
    "lat": 50.78,
    "lng": -1.09,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 27,
      "monthEnd": 8,
      "dayEnd": 29
    },
    "primaryRisk": "storms",
    "indicator": "mixed",
    "genre": [
      "indie",
      "rock",
      "pop"
    ],
    "website": "https://www.victoriousfestival.co.uk/",
    "camping": "off-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.victoriousfestival.co.uk/"
    },
    "cardOneLiner": "Seafront stages, live bands and a bank holiday in Southsea.",
    "blurb": "Seafront stages, live bands and a bank holiday in Southsea.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-27",
        "end": "2027-08-29",
        "sourceUrl": "https://www.victoriousfestival.co.uk/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-victorious"
  },
  {
    "slug": "truck",
    "name": "Truck Festival",
    "city": "Hill Farm, Steventon",
    "country": "UK",
    "lat": 51.62,
    "lng": -1.32,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 23,
      "monthEnd": 7,
      "dayEnd": 26
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "indie",
      "rock"
    ],
    "website": "https://truckfestival.com/faqs/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://truckfestival.com/faqs/",
      "note": "Exact dates for the next edition were not verified. The calendar shows typical timing with Dates TBC."
    },
    "cardOneLiner": "An Oxfordshire farm weekender built around indie bands and new discoveries.",
    "blurb": "An Oxfordshire farm weekender built around indie bands and new discoveries.",
    "jobsFilter": "season=festival&location=fest-truck"
  },
  {
    "slug": "y-not",
    "name": "Y Not Festival",
    "city": "Pikehall, Derbyshire",
    "country": "UK",
    "lat": 53.14,
    "lng": -1.73,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 29,
      "monthEnd": 8,
      "dayEnd": 1
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "indie",
      "rock",
      "multi-genre"
    ],
    "website": "https://ynotfestival.com/faqs/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://ynotfestival.com/faqs/",
      "note": "The official FAQ has conflicting weekday and date text for 2027. Exact dates remain unconfirmed here."
    },
    "cardOneLiner": "Guitar bands and a camping weekend in the Derbyshire countryside.",
    "blurb": "Guitar bands and a camping weekend in the Derbyshire countryside.",
    "jobsFilter": "season=festival&location=fest-y-not"
  },
  {
    "slug": "bloodstock",
    "name": "Bloodstock Open Air",
    "city": "Catton Park, Derbyshire",
    "country": "UK",
    "lat": 52.75,
    "lng": -1.69,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 5,
      "monthEnd": 8,
      "dayEnd": 8
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "metal",
      "rock"
    ],
    "website": "https://bloodstock.uk.com/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://bloodstock.uk.com/"
    },
    "cardOneLiner": "Heavy metal across the stages and campsites of Catton Park.",
    "blurb": "Heavy metal across the stages and campsites of Catton Park.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-05",
        "end": "2027-08-08",
        "sourceUrl": "https://bloodstock.uk.com/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-bloodstock"
  },
  {
    "slug": "bearded-theory",
    "name": "Bearded Theory",
    "city": "Catton Park, Derbyshire",
    "country": "UK",
    "lat": 52.75,
    "lng": -1.69,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 5,
      "dayStart": 26,
      "monthEnd": 5,
      "dayEnd": 30
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "folk",
      "multi-genre"
    ],
    "website": "https://beardedtheory.co.uk/explore/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://beardedtheory.co.uk/explore/"
    },
    "cardOneLiner": "Alternative music, family activities and camping beside the River Trent.",
    "blurb": "Alternative music, family activities and camping beside the River Trent.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-05-26",
        "end": "2027-05-30",
        "sourceUrl": "https://beardedtheory.co.uk/explore/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-bearded-theory"
  },
  {
    "slug": "beautiful-days",
    "name": "Beautiful Days",
    "city": "Escot Park, Devon",
    "country": "UK",
    "lat": 50.79,
    "lng": -3.29,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 20,
      "monthEnd": 8,
      "dayEnd": 22
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "folk",
      "rock",
      "multi-genre"
    ],
    "website": "https://www.beautifuldays.org/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.beautifuldays.org/"
    },
    "cardOneLiner": "The Levellers' independent festival with folk, rock, theatre and family camping.",
    "blurb": "The Levellers' independent festival with folk, rock, theatre and family camping.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-20",
        "end": "2027-08-22",
        "sourceUrl": "https://www.beautifuldays.org/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-beautiful-days"
  },
  {
    "slug": "2000trees",
    "name": "2000trees",
    "city": "Upcote Farm, Gloucestershire",
    "country": "UK",
    "lat": 51.83,
    "lng": -2.02,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 7,
      "monthEnd": 7,
      "dayEnd": 10
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "indie",
      "metal"
    ],
    "website": "https://2000trees.co.uk/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://2000trees.co.uk/"
    },
    "cardOneLiner": "Alternative rock and new bands in the Gloucestershire countryside.",
    "blurb": "Alternative rock and new bands in the Gloucestershire countryside.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-07",
        "end": "2027-07-10",
        "sourceUrl": "https://2000trees.co.uk/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-2000trees"
  },
  {
    "slug": "slam-dunk-north",
    "name": "Slam Dunk North",
    "city": "Temple Newsam, Leeds",
    "country": "UK",
    "lat": 53.79,
    "lng": -1.46,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 5,
      "dayStart": 29,
      "monthEnd": 5,
      "dayEnd": 29
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "metal"
    ],
    "website": "https://www.slamdunkfestival.com/info",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.slamdunkfestival.com/info"
    },
    "cardOneLiner": "A day of pop-punk, emo and heavy music at Temple Newsam.",
    "blurb": "A day of pop-punk, emo and heavy music at Temple Newsam.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-05-29",
        "end": "2027-05-29",
        "sourceUrl": "https://www.slamdunkfestival.com/info",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-slam-dunk-north"
  },
  {
    "slug": "slam-dunk-south",
    "name": "Slam Dunk South",
    "city": "Hatfield Park, Hertfordshire",
    "country": "UK",
    "lat": 51.76,
    "lng": -0.21,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 5,
      "dayStart": 30,
      "monthEnd": 5,
      "dayEnd": 30
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "metal"
    ],
    "website": "https://www.slamdunkfestival.com/info",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.slamdunkfestival.com/info"
    },
    "cardOneLiner": "Slam Dunk's southern stop brings pop-punk and heavy music to Hatfield Park.",
    "blurb": "Slam Dunk's southern stop brings pop-punk and heavy music to Hatfield Park.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-05-30",
        "end": "2027-05-30",
        "sourceUrl": "https://www.slamdunkfestival.com/info",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-slam-dunk-south"
  },
  {
    "slug": "lost-village",
    "name": "Lost Village",
    "city": "Norton Disney, Lincolnshire",
    "country": "UK",
    "lat": 53.13,
    "lng": -0.7,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 26,
      "monthEnd": 8,
      "dayEnd": 29
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "electronic",
      "dance",
      "boutique"
    ],
    "website": "https://lostvillagefestival.com/information/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://lostvillagefestival.com/information/"
    },
    "cardOneLiner": "Electronic music, forest stages, food and workshops in Lincolnshire.",
    "blurb": "Electronic music, forest stages, food and workshops in Lincolnshire.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-26",
        "end": "2027-08-29",
        "sourceUrl": "https://lostvillagefestival.com/information/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-lost-village"
  },
  {
    "slug": "wilderness",
    "name": "Wilderness",
    "city": "Cornbury Park, Oxfordshire",
    "country": "UK",
    "lat": 51.86,
    "lng": -1.49,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 1,
      "monthEnd": 8,
      "dayEnd": 4
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "multi-genre",
      "boutique"
    ],
    "website": "https://www.wildernessfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.wildernessfestival.com/",
      "note": "Exact dates for the next edition were not verified. The calendar shows typical timing with Dates TBC."
    },
    "cardOneLiner": "Music and arts in the parkland of Cornbury, near Charlbury.",
    "blurb": "Music and arts in the parkland of Cornbury, near Charlbury.",
    "jobsFilter": "season=festival&location=fest-wilderness"
  },
  {
    "slug": "tramlines",
    "name": "Tramlines",
    "city": "Hillsborough Park, Sheffield",
    "country": "UK",
    "lat": 53.41,
    "lng": -1.5,
    "region": "uk",
    "timezone": "Europe/London",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 23,
      "monthEnd": 7,
      "dayEnd": 25
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "indie",
      "rock",
      "pop"
    ],
    "website": "https://tramlines.org.uk/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://tramlines.org.uk/",
      "note": "Exact dates for the next edition were not verified. The calendar shows typical timing with Dates TBC."
    },
    "cardOneLiner": "Sheffield's park festival mixes headline bands, local music and comedy.",
    "blurb": "Sheffield's park festival mixes headline bands, local music and comedy.",
    "jobsFilter": "season=festival&location=fest-tramlines"
  },
  {
    "slug": "electric-picnic",
    "name": "Electric Picnic",
    "city": "Stradbally, County Laois",
    "country": "Ireland",
    "lat": 53.01,
    "lng": -7.15,
    "region": "europe",
    "timezone": "Europe/Dublin",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 27,
      "monthEnd": 8,
      "dayEnd": 29
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "multi-genre",
      "indie",
      "electronic"
    ],
    "website": "https://www.electricpicnic.ie/line-up",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.electricpicnic.ie/line-up"
    },
    "cardOneLiner": "Music and arts across the grounds of Stradbally Hall.",
    "blurb": "Music and arts across the grounds of Stradbally Hall.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-27",
        "end": "2027-08-29",
        "sourceUrl": "https://www.electricpicnic.ie/line-up",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-electric-picnic"
  },
  {
    "slug": "rock-am-ring",
    "name": "Rock am Ring",
    "city": "Nürburgring",
    "country": "Germany",
    "lat": 50.34,
    "lng": 6.95,
    "region": "europe",
    "timezone": "Europe/Berlin",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 4,
      "monthEnd": 6,
      "dayEnd": 6
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "metal"
    ],
    "website": "https://www.rock-am-ring.com/en/info",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.rock-am-ring.com/en/info"
    },
    "cardOneLiner": "Rock and metal at the Nürburgring, with camping around the circuit.",
    "blurb": "Rock and metal at the Nürburgring, with camping around the circuit.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-04",
        "end": "2027-06-06",
        "sourceUrl": "https://www.rock-am-ring.com/en/info",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-rock-am-ring"
  },
  {
    "slug": "rock-im-park",
    "name": "Rock im Park",
    "city": "Nuremberg",
    "country": "Germany",
    "lat": 49.43,
    "lng": 11.12,
    "region": "europe",
    "timezone": "Europe/Berlin",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 4,
      "monthEnd": 6,
      "dayEnd": 6
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "metal"
    ],
    "website": "https://www.rock-im-park.com/en/info",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.rock-im-park.com/en/info"
    },
    "cardOneLiner": "Nuremberg's rock and metal weekend, paired with Rock am Ring.",
    "blurb": "Nuremberg's rock and metal weekend, paired with Rock am Ring.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-04",
        "end": "2027-06-06",
        "sourceUrl": "https://www.rock-im-park.com/en/info",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-rock-im-park"
  },
  {
    "slug": "wacken",
    "name": "Wacken Open Air",
    "city": "Wacken",
    "country": "Germany",
    "lat": 54.02,
    "lng": 9.38,
    "region": "europe",
    "timezone": "Europe/Berlin",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 28,
      "monthEnd": 7,
      "dayEnd": 31
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "metal",
      "rock"
    ],
    "website": "https://faq.wacken.com/en-us/43-w-o-a-2026/536-when-will-w-o-a-2026-take-place",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://faq.wacken.com/en-us/43-w-o-a-2026/536-when-will-w-o-a-2026-take-place"
    },
    "cardOneLiner": "Metal fans gather in the village and fields of Wacken.",
    "blurb": "Metal fans gather in the village and fields of Wacken.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-28",
        "end": "2027-07-31",
        "sourceUrl": "https://faq.wacken.com/en-us/43-w-o-a-2026/536-when-will-w-o-a-2026-take-place",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-wacken"
  },
  {
    "slug": "pukkelpop",
    "name": "Pukkelpop",
    "city": "Kiewit, Hasselt",
    "country": "Belgium",
    "lat": 50.96,
    "lng": 5.35,
    "region": "europe",
    "timezone": "Europe/Brussels",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 19,
      "monthEnd": 8,
      "dayEnd": 22
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "multi-genre",
      "indie",
      "electronic"
    ],
    "website": "https://www.pukkelpop.be/en/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.pukkelpop.be/en/"
    },
    "cardOneLiner": "Alternative bands and electronic stages in Kiewit, near Hasselt.",
    "blurb": "Alternative bands and electronic stages in Kiewit, near Hasselt.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-19",
        "end": "2027-08-22",
        "sourceUrl": "https://www.pukkelpop.be/en/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-pukkelpop"
  },
  {
    "slug": "hurricane",
    "name": "Hurricane Festival",
    "city": "Scheeßel",
    "country": "Germany",
    "lat": 53.17,
    "lng": 9.48,
    "region": "europe",
    "timezone": "Europe/Berlin",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 18,
      "monthEnd": 6,
      "dayEnd": 20
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "indie",
      "multi-genre"
    ],
    "website": "https://hurricane.de/en/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://hurricane.de/en/"
    },
    "cardOneLiner": "Rock, indie and electronic music with a camping weekend at the Eichenring.",
    "blurb": "Rock, indie and electronic music with a camping weekend at the Eichenring.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-18",
        "end": "2027-06-20",
        "sourceUrl": "https://hurricane.de/en/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-hurricane"
  },
  {
    "slug": "southside",
    "name": "Southside Festival",
    "city": "Neuhausen ob Eck",
    "country": "Germany",
    "lat": 47.98,
    "lng": 8.91,
    "region": "europe",
    "timezone": "Europe/Berlin",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 18,
      "monthEnd": 6,
      "dayEnd": 20
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "indie",
      "multi-genre"
    ],
    "website": "https://southside.de/en/info/camping-caravan/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://southside.de/en/info/camping-caravan/"
    },
    "cardOneLiner": "Hurricane's southern counterpart on the airfield at Neuhausen ob Eck.",
    "blurb": "Hurricane's southern counterpart on the airfield at Neuhausen ob Eck.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-18",
        "end": "2027-06-20",
        "sourceUrl": "https://southside.de/en/info/camping-caravan/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-southside"
  },
  {
    "slug": "graspop",
    "name": "Graspop Metal Meeting",
    "city": "Dessel",
    "country": "Belgium",
    "lat": 51.24,
    "lng": 5.09,
    "region": "europe",
    "timezone": "Europe/Brussels",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 17,
      "monthEnd": 6,
      "dayEnd": 20
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "metal",
      "rock"
    ],
    "website": "https://press.graspop.be/graspop-metal-meeting-2026-une-fusion-des-genres-extremes-et-des-passionnes-de-metal",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://press.graspop.be/graspop-metal-meeting-2026-une-fusion-des-genres-extremes-et-des-passionnes-de-metal"
    },
    "cardOneLiner": "Four days of metal and hard rock in Dessel.",
    "blurb": "Four days of metal and hard rock in Dessel.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-17",
        "end": "2027-06-20",
        "sourceUrl": "https://press.graspop.be/graspop-metal-meeting-2026-une-fusion-des-genres-extremes-et-des-passionnes-de-metal",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-graspop"
  },
  {
    "slug": "nos-alive",
    "name": "NOS Alive",
    "city": "Algés, Lisbon",
    "country": "Portugal",
    "lat": 38.7,
    "lng": -9.23,
    "region": "europe",
    "timezone": "Europe/Lisbon",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 8,
      "monthEnd": 7,
      "dayEnd": 10
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "rock",
      "indie",
      "multi-genre"
    ],
    "website": "https://nosalive.com/en/tame-impala-confirmed-for-the-nos-stage-on-july-10/",
    "camping": "off-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://nosalive.com/en/tame-impala-confirmed-for-the-nos-stage-on-july-10/"
    },
    "cardOneLiner": "Live bands and electronic music beside the Tagus, just outside Lisbon.",
    "blurb": "Live bands and electronic music beside the Tagus, just outside Lisbon.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-08",
        "end": "2027-07-10",
        "sourceUrl": "https://nosalive.com/en/tame-impala-confirmed-for-the-nos-stage-on-july-10/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-nos-alive"
  },
  {
    "slug": "mad-cool",
    "name": "Mad Cool",
    "city": "Madrid",
    "country": "Spain",
    "lat": 40.33,
    "lng": -3.69,
    "region": "europe",
    "timezone": "Europe/Madrid",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 8,
      "monthEnd": 7,
      "dayEnd": 11
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "rock",
      "indie",
      "multi-genre"
    ],
    "website": "https://madcoolfestival.es/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://madcoolfestival.es/",
      "note": "Exact dates for the next edition were not verified. The calendar shows typical timing with Dates TBC."
    },
    "cardOneLiner": "International rock, pop and electronic acts in Madrid.",
    "blurb": "International rock, pop and electronic acts in Madrid.",
    "jobsFilter": "season=festival&location=fest-mad-cool"
  },
  {
    "slug": "sonar",
    "name": "Sónar Barcelona",
    "city": "Barcelona",
    "country": "Spain",
    "lat": 41.35,
    "lng": 2.13,
    "region": "europe",
    "timezone": "Europe/Madrid",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 17,
      "monthEnd": 6,
      "dayEnd": 19
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "electronic",
      "dance"
    ],
    "website": "https://sonar.es/en",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://sonar.es/en"
    },
    "cardOneLiner": "Electronic music meets creative technology and experimental performance.",
    "blurb": "Electronic music meets creative technology and experimental performance.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-17",
        "end": "2027-06-19",
        "sourceUrl": "https://sonar.es/en",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-sonar"
  },
  {
    "slug": "opener",
    "name": "Open'er Festival",
    "city": "Gdynia-Kosakowo",
    "country": "Poland",
    "lat": 54.58,
    "lng": 18.52,
    "region": "europe",
    "timezone": "Europe/Warsaw",
    "typicalWindow": {
      "monthStart": 6,
      "dayStart": 30,
      "monthEnd": 7,
      "dayEnd": 3
    },
    "primaryRisk": "storms",
    "indicator": "mixed",
    "genre": [
      "multi-genre",
      "rock",
      "electronic"
    ],
    "website": "https://opener.pl/en",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://opener.pl/en"
    },
    "cardOneLiner": "Live bands and electronic acts at Gdynia-Kosakowo airfield.",
    "blurb": "Live bands and electronic acts at Gdynia-Kosakowo airfield.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-06-30",
        "end": "2027-07-03",
        "sourceUrl": "https://opener.pl/en",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-opener"
  },
  {
    "slug": "rock-en-seine",
    "name": "Rock en Seine",
    "city": "Saint-Cloud, Paris",
    "country": "France",
    "lat": 48.83,
    "lng": 2.22,
    "region": "europe",
    "timezone": "Europe/Paris",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 26,
      "monthEnd": 8,
      "dayEnd": 30
    },
    "primaryRisk": "mud",
    "indicator": "mixed",
    "genre": [
      "rock",
      "indie",
      "multi-genre"
    ],
    "website": "https://www.rockenseine.com/en/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.rockenseine.com/en/",
      "note": "Exact dates for the next edition were not verified. The calendar shows typical timing with Dates TBC."
    },
    "cardOneLiner": "Late-summer bands in the Domaine National de Saint-Cloud, outside Paris.",
    "blurb": "Late-summer bands in the Domaine National de Saint-Cloud, outside Paris.",
    "jobsFilter": "season=festival&location=fest-rock-en-seine"
  },
  {
    "slug": "snowbombing",
    "name": "Snowbombing",
    "city": "Mayrhofen",
    "country": "Austria",
    "lat": 47.17,
    "lng": 11.87,
    "region": "europe",
    "timezone": "Europe/Vienna",
    "typicalWindow": {
      "monthStart": 4,
      "dayStart": 5,
      "monthEnd": 4,
      "dayEnd": 10
    },
    "primaryRisk": "cold",
    "indicator": "cold",
    "genre": [
      "electronic",
      "dance"
    ],
    "website": "https://snowbombing.com/info",
    "camping": "none",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://snowbombing.com/info"
    },
    "cardOneLiner": "Ski days, mountain parties and electronic music in Mayrhofen.",
    "blurb": "Ski days, mountain parties and electronic music in Mayrhofen.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-04-05",
        "end": "2027-04-10",
        "sourceUrl": "https://snowbombing.com/info",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-snowbombing"
  },
  {
    "slug": "snowboxx",
    "name": "Snowboxx",
    "city": "Avoriaz",
    "country": "France",
    "lat": 46.19,
    "lng": 6.77,
    "region": "europe",
    "timezone": "Europe/Paris",
    "typicalWindow": {
      "monthStart": 3,
      "dayStart": 13,
      "monthEnd": 3,
      "dayEnd": 20
    },
    "primaryRisk": "cold",
    "indicator": "cold",
    "genre": [
      "electronic",
      "dance"
    ],
    "website": "https://www.snowboxx.com/faq",
    "camping": "none",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.snowboxx.com/faq"
    },
    "cardOneLiner": "A week of skiing, après and electronic music in Avoriaz.",
    "blurb": "A week of skiing, après and electronic music in Avoriaz.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-03-13",
        "end": "2027-03-20",
        "sourceUrl": "https://www.snowboxx.com/faq",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-snowboxx"
  },
  {
    "slug": "tomorrowland-winter",
    "name": "Tomorrowland Winter",
    "city": "Alpe d'Huez",
    "country": "France",
    "lat": 45.09,
    "lng": 6.07,
    "region": "europe",
    "timezone": "Europe/Paris",
    "typicalWindow": {
      "monthStart": 3,
      "dayStart": 20,
      "monthEnd": 3,
      "dayEnd": 27
    },
    "primaryRisk": "cold",
    "indicator": "cold",
    "genre": [
      "electronic",
      "dance"
    ],
    "website": "https://winter.tomorrowland.com/en/tickets/",
    "camping": "none",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://winter.tomorrowland.com/en/tickets/"
    },
    "cardOneLiner": "Tomorrowland's mountain edition pairs electronic stages with the ski slopes.",
    "blurb": "Tomorrowland's mountain edition pairs electronic stages with the ski slopes.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-03-20",
        "end": "2027-03-27",
        "sourceUrl": "https://winter.tomorrowland.com/en/tickets/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-tomorrowland-winter"
  },
  {
    "slug": "austin-city-limits",
    "name": "Austin City Limits",
    "city": "Zilker Park, Austin",
    "country": "USA",
    "lat": 30.27,
    "lng": -97.77,
    "region": "north-america",
    "timezone": "America/Chicago",
    "typicalWindow": {
      "monthStart": 10,
      "dayStart": 2,
      "monthEnd": 10,
      "dayEnd": 11
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "multi-genre",
      "rock",
      "indie"
    ],
    "website": "https://www.aclfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.aclfestival.com/"
    },
    "cardOneLiner": "Two October weekends of live music in Austin's Zilker Park.",
    "blurb": "Two October weekends of live music in Austin's Zilker Park.",
    "confirmedDates": [
      {
        "year": 2026,
        "start": "2026-10-02",
        "end": "2026-10-11",
        "sourceUrl": "https://www.aclfestival.com/",
        "checkedAt": "2026-09-20",
        "weekends": [
          {
            "label": "Weekend 1",
            "start": "2026-10-02",
            "end": "2026-10-04"
          },
          {
            "label": "Weekend 2",
            "start": "2026-10-09",
            "end": "2026-10-11"
          }
        ]
      }
    ],
    "jobsFilter": "season=festival&location=fest-austin-city-limits"
  },
  {
    "slug": "ultra-miami",
    "name": "Ultra Miami",
    "city": "Bayfront Park, Miami",
    "country": "USA",
    "lat": 25.79,
    "lng": -80.19,
    "region": "north-america",
    "timezone": "America/New_York",
    "typicalWindow": {
      "monthStart": 3,
      "dayStart": 26,
      "monthEnd": 3,
      "dayEnd": 28
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "electronic",
      "dance"
    ],
    "website": "https://ultramusicfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://ultramusicfestival.com/"
    },
    "cardOneLiner": "Electronic music on Miami's waterfront at Bayfront Park.",
    "blurb": "Electronic music on Miami's waterfront at Bayfront Park.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-03-26",
        "end": "2027-03-28",
        "sourceUrl": "https://ultramusicfestival.com/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-ultra-miami"
  },
  {
    "slug": "shaky-knees",
    "name": "Shaky Knees",
    "city": "Atlanta",
    "country": "USA",
    "lat": 33.79,
    "lng": -84.37,
    "region": "north-america",
    "timezone": "America/New_York",
    "typicalWindow": {
      "monthStart": 9,
      "dayStart": 18,
      "monthEnd": 9,
      "dayEnd": 20
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "rock",
      "indie"
    ],
    "website": "https://www.shakykneesfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.shakykneesfestival.com/"
    },
    "cardOneLiner": "An Atlanta weekend for guitar bands and indie discoveries.",
    "blurb": "An Atlanta weekend for guitar bands and indie discoveries.",
    "confirmedDates": [
      {
        "year": 2026,
        "start": "2026-09-18",
        "end": "2026-09-20",
        "sourceUrl": "https://www.shakykneesfestival.com/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-shaky-knees"
  },
  {
    "slug": "outside-lands",
    "name": "Outside Lands",
    "city": "Golden Gate Park, San Francisco",
    "country": "USA",
    "lat": 37.77,
    "lng": -122.49,
    "region": "north-america",
    "timezone": "America/Los_Angeles",
    "typicalWindow": {
      "monthStart": 8,
      "dayStart": 6,
      "monthEnd": 8,
      "dayEnd": 8
    },
    "primaryRisk": "cold",
    "indicator": "cold",
    "genre": [
      "multi-genre",
      "indie",
      "electronic"
    ],
    "website": "https://sfoutsidelands.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://sfoutsidelands.com/"
    },
    "cardOneLiner": "Music, food and art among the trees of Golden Gate Park.",
    "blurb": "Music, food and art among the trees of Golden Gate Park.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-08-06",
        "end": "2027-08-08",
        "sourceUrl": "https://sfoutsidelands.com/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-outside-lands"
  },
  {
    "slug": "stagecoach",
    "name": "Stagecoach",
    "city": "Indio, California",
    "country": "USA",
    "lat": 33.68,
    "lng": -116.24,
    "region": "north-america",
    "timezone": "America/Los_Angeles",
    "typicalWindow": {
      "monthStart": 4,
      "dayStart": 23,
      "monthEnd": 4,
      "dayEnd": 25
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "country",
      "rock"
    ],
    "website": "https://www.stagecoachfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.stagecoachfestival.com/",
      "note": "Exact dates for the next edition were not verified. The calendar shows typical timing with Dates TBC."
    },
    "cardOneLiner": "Country music and desert evenings at the Empire Polo Club.",
    "blurb": "Country music and desert evenings at the Empire Polo Club.",
    "jobsFilter": "season=festival&location=fest-stagecoach"
  },
  {
    "slug": "shambhala-canada",
    "name": "Shambhala Music Festival",
    "city": "Salmo, British Columbia",
    "country": "Canada",
    "lat": 49.08,
    "lng": -117.28,
    "region": "north-america",
    "timezone": "America/Vancouver",
    "typicalWindow": {
      "monthStart": 7,
      "dayStart": 23,
      "monthEnd": 7,
      "dayEnd": 26
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "electronic",
      "dance"
    ],
    "website": "https://www.shambhalamusicfestival.com/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.shambhalamusicfestival.com/"
    },
    "cardOneLiner": "Electronic music and riverside stages at Salmo River Ranch.",
    "blurb": "Electronic music and riverside stages at Salmo River Ranch.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-07-23",
        "end": "2027-07-26",
        "sourceUrl": "https://www.shambhalamusicfestival.com/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-shambhala-canada"
  },
  {
    "slug": "golden-plains",
    "name": "Golden Plains",
    "city": "Meredith, Victoria",
    "country": "Australia",
    "lat": -37.99,
    "lng": 144.08,
    "region": "anz",
    "timezone": "Australia/Melbourne",
    "typicalWindow": {
      "monthStart": 3,
      "dayStart": 6,
      "monthEnd": 3,
      "dayEnd": 8
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "multi-genre",
      "indie",
      "electronic"
    ],
    "website": "https://goldenplains.com.au/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://goldenplains.com.au/"
    },
    "cardOneLiner": "A long weekend of music at the Meredith Supernatural Amphitheatre.",
    "blurb": "A long weekend of music at the Meredith Supernatural Amphitheatre.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-03-06",
        "end": "2027-03-08",
        "sourceUrl": "https://goldenplains.com.au/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-golden-plains"
  },
  {
    "slug": "meredith",
    "name": "Meredith Music Festival",
    "city": "Meredith, Victoria",
    "country": "Australia",
    "lat": -37.99,
    "lng": 144.08,
    "region": "anz",
    "timezone": "Australia/Melbourne",
    "typicalWindow": {
      "monthStart": 12,
      "dayStart": 11,
      "monthEnd": 12,
      "dayEnd": 13
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "multi-genre",
      "indie",
      "electronic"
    ],
    "website": "https://mmf.com.au/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://mmf.com.au/"
    },
    "cardOneLiner": "A single-stage camping festival at the Meredith Supernatural Amphitheatre.",
    "blurb": "A single-stage camping festival at the Meredith Supernatural Amphitheatre.",
    "confirmedDates": [
      {
        "year": 2026,
        "start": "2026-12-11",
        "end": "2026-12-13",
        "sourceUrl": "https://mmf.com.au/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-meredith"
  },
  {
    "slug": "woodford-folk",
    "name": "Woodford Folk Festival",
    "city": "Woodford, Queensland",
    "country": "Australia",
    "lat": -26.94,
    "lng": 152.69,
    "region": "anz",
    "timezone": "Australia/Brisbane",
    "typicalWindow": {
      "monthStart": 12,
      "dayStart": 27,
      "monthEnd": 1,
      "dayEnd": 1
    },
    "primaryRisk": "storms",
    "indicator": "mixed",
    "genre": [
      "folk",
      "world",
      "multi-genre"
    ],
    "website": "https://woodfordfolkfestival.com/",
    "camping": "on-site",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://woodfordia.org/looking-ahead-to-2026-and-seeking-connections-to-community/"
    },
    "cardOneLiner": "Music, arts and community at Woodfordia across the New Year.",
    "blurb": "Music, arts and community at Woodfordia across the New Year.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2026-12-27",
        "end": "2027-01-01",
        "sourceUrl": "https://woodfordia.org/looking-ahead-to-2026-and-seeking-connections-to-community/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-woodford-folk"
  },
  {
    "slug": "rhythm-and-alps",
    "name": "Rhythm and Alps",
    "city": "Cardrona Valley, Wānaka",
    "country": "New Zealand",
    "lat": -44.93,
    "lng": 169.02,
    "region": "anz",
    "timezone": "Pacific/Auckland",
    "typicalWindow": {
      "monthStart": 12,
      "dayStart": 30,
      "monthEnd": 12,
      "dayEnd": 31
    },
    "primaryRisk": "cold",
    "indicator": "cold",
    "genre": [
      "electronic",
      "dance",
      "multi-genre"
    ],
    "website": "https://rhythmandalps.co.nz/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://rhythmandalps.co.nz/"
    },
    "cardOneLiner": "Live music and electronic stages beneath the mountains near Wānaka.",
    "blurb": "Live music and electronic stages beneath the mountains near Wānaka.",
    "confirmedDates": [
      {
        "year": 2026,
        "start": "2026-12-30",
        "end": "2026-12-31",
        "sourceUrl": "https://rhythmandalps.co.nz/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-rhythm-and-alps"
  },
  {
    "slug": "northern-bass",
    "name": "Northern Bass",
    "city": "Mangawhai",
    "country": "New Zealand",
    "lat": -36.13,
    "lng": 174.51,
    "region": "anz",
    "timezone": "Pacific/Auckland",
    "typicalWindow": {
      "monthStart": 12,
      "dayStart": 30,
      "monthEnd": 12,
      "dayEnd": 31
    },
    "primaryRisk": "storms",
    "indicator": "mixed",
    "genre": [
      "electronic",
      "dance",
      "hip-hop"
    ],
    "website": "https://northernbass.co.nz/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://northernbass.co.nz/"
    },
    "cardOneLiner": "Bass music and a New Year gathering in Northland.",
    "blurb": "Bass music and a New Year gathering in Northland.",
    "confirmedDates": [
      {
        "year": 2026,
        "start": "2026-12-30",
        "end": "2026-12-31",
        "sourceUrl": "https://northernbass.co.nz/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-northern-bass"
  },
  {
    "slug": "womadelaide",
    "name": "WOMADelaide",
    "city": "Botanic Park, Adelaide",
    "country": "Australia",
    "lat": -34.91,
    "lng": 138.61,
    "region": "anz",
    "timezone": "Australia/Adelaide",
    "typicalWindow": {
      "monthStart": 3,
      "dayStart": 5,
      "monthEnd": 3,
      "dayEnd": 8
    },
    "primaryRisk": "heat",
    "indicator": "hot",
    "genre": [
      "world",
      "folk",
      "multi-genre"
    ],
    "website": "https://www.womadelaide.com.au/",
    "camping": "check-organiser",
    "review": {
      "checkedAt": "2026-09-20",
      "sourceUrl": "https://www.womadelaide.com.au/"
    },
    "cardOneLiner": "Music from around the world in Adelaide's Botanic Park.",
    "blurb": "Music from around the world in Adelaide's Botanic Park.",
    "confirmedDates": [
      {
        "year": 2027,
        "start": "2027-03-05",
        "end": "2027-03-08",
        "sourceUrl": "https://www.womadelaide.com.au/",
        "checkedAt": "2026-09-20"
      }
    ],
    "jobsFilter": "season=festival&location=fest-womadelaide"
  }
];
